import type { SilktideConfig } from '@/silktide/types/silktide'
import { getI18n } from '@/plugins/i18n'

const grantNecessary = () => {
  window.gtag?.('consent', 'update', {})

  window.dataLayer?.push({
    event: 'consent_accepted_necessary_cookies',
  })
}

const denyNecessary = () => {
  window.gtag?.('consent', 'update', {})
}

const grantPerformance = () => {
  window.gtag?.('consent', 'update', {
    analytics_storage: 'granted',
  })

  window.dataLayer?.push({
    event: 'consent_accepted_performance_cookies',
  })
}

const denyPerformance = () => {
  window.gtag?.('consent', 'update', {
    analytics_storage: 'denied',
  })
}

export function buildCookieBannerConfig(): SilktideConfig {
  const { t } = getI18n().global as { t: (key: string) => string }

  return {
    background: {
      showBackground: true,
    },
    cookieIcon: {
      position: 'bottomLeft',
    },
    cookieTypes: [
      {
        id: 'necessary',
        name: t('cookieTypes.necessary.name'),
        description: t('cookieTypes.necessary.description'),
        required: true,
        onAccept: grantNecessary,
        onReject: denyNecessary,
      },
      {
        id: 'performance',
        name: t('cookieTypes.performance.name'),
        description: t('cookieTypes.performance.description'),
        required: false,
        onAccept: grantPerformance,
        onReject: denyPerformance,
      },
    ],
    text: {
      banner: {
        description: t('cookies.text.banner.description'),
        acceptAllButtonText: t('cookies.text.banner.acceptAllButton'),
        rejectNonEssentialButtonText: t(
          'cookies.text.banner.rejectNonEssentialButton',
        ),
        preferencesButtonText: t('cookies.text.banner.preferencesButton'),
      },
      preferences: {
        title: t('cookies.text.preferences.title'),
        description: t('cookies.text.preferences.description'),
      },
    },
    position: {
      banner: 'bottomCenter',
    },
  }
}
